/**
 * API 版本管理中间件
 */

import { Request, Response, NextFunction } from 'express';
import { API_VERSIONS } from '../config.js';

export function versionMiddleware(req: Request, res: Response, next: NextFunction): void {
  // 从 URL 或 header 中获取版本
  const urlMatch = req.path.match(/\/api\/v(\d+)/);
  const headerVersion = req.headers['x-api-version'] as string;
  
  let version = urlMatch ? `v${urlMatch[1]}` : headerVersion || API_VERSIONS.current;
  
  // 验证版本
  if (!API_VERSIONS.supported.includes(version)) {
    version = API_VERSIONS.current;
  }
  
  // 设置版本到 request 对象
  (req as any).apiVersion = version;
  
  // 添加版本相关的响应头
  res.setHeader('X-API-Version', version);
  
  // 如果使用已废弃的版本，添加警告
  if (API_VERSIONS.deprecated.includes(version)) {
    const sunsetDate = (API_VERSIONS.sunset as any)[version];
    res.setHeader('X-API-Deprecation', 'true');
    res.setHeader('X-API-Deprecation-Date', sunsetDate || 'TBD');
    res.setHeader(
      'X-API-Deprecation-Info',
      `This API version is deprecated and will be removed after ${sunsetDate}. Please upgrade to ${API_VERSIONS.current}.`
    );
  }
  
  next();
}

// 版本信息端点处理器
export function versionInfoHandler(req: Request, res: Response): void {
  res.json({
    current: API_VERSIONS.current,
    supported: API_VERSIONS.supported,
    deprecated: API_VERSIONS.deprecated,
    sunset: API_VERSIONS.sunset,
    requestedVersion: (req as any).apiVersion,
  });
}